import PartnersLayout from '../Components/Partners/PartnersLayout'

/** Admin floor plans + engagement — partner scope comes from the sidebar partner selector. */
const FloorPlans = () => <PartnersLayout />

export default FloorPlans
